import React, { useState, useEffect } from 'react';
import settingsManager from '../utils/settingsManager.js';
import LetterTile from './LetterTile.js';
import './LetterSettings.css';

export default function LetterSettings({ onClose }) {
  const [settings, setSettings] = useState({});
  const [isModified, setIsModified] = useState(false);

  useEffect(() => {
    const currentSettings = settingsManager.getSettings();
    setSettings(currentSettings);
  }, []);

  const handlePointsChange = (letter, newPoints) => {
    const updatedSettings = {
      ...settings,
      [letter]: {
        ...settings[letter],
        points: parseInt(newPoints) || 0
      }
    };
    setSettings(updatedSettings);
    setIsModified(true);
  };

  const handlePropertyChange = (letter, property, value) => {
    const updatedSettings = {
      ...settings,
      [letter]: {
        ...settings[letter],
        [property]: value
      }
    };
    setSettings(updatedSettings);
    setIsModified(true);
  };

  const saveSettings = () => {
    settingsManager.saveSettings(settings);
    setIsModified(false);
    alert('Settings saved successfully!');
  };

  const resetToDefaults = () => {
    if (window.confirm('Are you sure you want to reset all settings to defaults?')) {
      const defaultSettings = settingsManager.resetToDefaults();
      setSettings(defaultSettings);
      setIsModified(false);
    }
  };

  const exportSettings = () => {
    const dataStr = JSON.stringify(settings, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'letter-settings.json';
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="settings-overlay">
      <div className="settings-modal">
        <div className="settings-header">
          <h2>Letter Settings</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="settings-content">
          <div className="settings-actions">
            <button onClick={saveSettings} disabled={!isModified} className="save-btn">
              Save Changes
            </button>
            <button onClick={resetToDefaults} className="reset-btn">
              Reset to Defaults
            </button>
            <button onClick={exportSettings} className="export-btn">
              Export Settings
            </button>
          </div>

          <div className="letters-grid">
            {Object.keys(settings).sort().map(letter => {
              const letterInfo = settings[letter];
              return (
                <div key={letter} className="letter-setting-card">
                  <div className="letter-display">
                    <LetterTile
                      letter={letter}
                      className="settings-letter-tile"
                      draggable={false}
                    />
                    <span className="letter-points-text">{letterInfo.points} pts</span>
                  </div>

                  <div className="letter-controls">
                    <label>
                      Points:
                      <input
                        type="number"
                        min="0"
                        max="20"
                        value={letterInfo.points}
                        onChange={(e) => handlePointsChange(letter, e.target.value)}
                      />
                    </label>

                    <div className="checkboxes">
                      <label>
                        <input
                          type="checkbox"
                          checked={letterInfo.isVowel}
                          onChange={(e) => handlePropertyChange(letter, 'isVowel', e.target.checked)}
                        />
                        Vowel
                      </label>

                      <label>
                        <input
                          type="checkbox"
                          checked={letterInfo.isRare}
                          onChange={(e) => handlePropertyChange(letter, 'isRare', e.target.checked)}
                        />
                        Rare
                      </label>

                      <label>
                        <input
                          type="checkbox"
                          checked={letterInfo.isSpecial}
                          onChange={(e) => handlePropertyChange(letter, 'isSpecial', e.target.checked)}
                        />
                        Special
                      </label>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
